import { DefaultTheme } from "@magnetic/react-components";
import Dialog from "./Dialog"
import styled, { css } from "../styled"; 

export const StyledDialog = styled(Dialog)(
  ({ theme: { Mag = DefaultTheme } }) => css`
    border-radius: ${Mag.border.borderRadius};
    box-shadow: 0 0 6px 0 ${Mag.color._veilBackground};
    padding: 0px;
    border: none;
    width: 600px;

    > .p-dialog-header {
      border: 1px solid ${Mag.color.border};
      color: ${Mag.color.text};
      border-bottom: 0 none;
      padding: ${Mag.space.spacer16} ${Mag.space.spacer20} !important;
      font-size: ${Mag.typography.fontSize16};
      font-weight: ${Mag.typography.fontWeightSemibold};
      border-top-left-radius: ${Mag.space.spacer04} !important;
      border-top-right-radius: ${Mag.space.spacer04} !important;
      background-color: ${Mag.color.backgroundMedium};      
    }

    > .p-dialog-content {
      background: ${Mag.color.background};
      color: ${Mag.color.text};
      border: 1px solid ${Mag.color.border};
      padding: 0 !important;
    }

    > .p-dialog-footer {
      border: 1px solid ${Mag.color.border};
      border-top: 0 none;
      color: ${Mag.color.text};
      padding: ${Mag.space.spacer08} 1rem;
      margin: 0;
      text-align: right;
      border-bottom-left-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
      background-color: ${Mag.color.backgroundMedium};

      button {
        margin: 0 0.5rem 0 0;
        width: auto;                
      }

    }   
      
    .collapsible-text {
      padding-left: ${Mag.space.spacer20};
    }

    .mi-icon-alert-filled-triangle {
      color: #e4a206;
      font-family: Mitchell-Icon-Fonts;
      font-size: 56px;
      line-height: 1;
      margin-right: 1rem;
      vertical-align: top;
    }

    .msgbox-container {
      display: flex;
    }
  `
);
